import { useState } from "react";
import { Button, Divider, Select, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { TicketViewModel } from "../../../interfaces";
import { SwapOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";

interface ProductsIntederfaceProps {
  ticket: TicketViewModel;
}
interface DataType {
  key: string;
  user: string;
  description: string;
  type: string;
  date: string;
}
const SplitTicket = ({ ticket }: ProductsIntederfaceProps) => {
  // const { token } = useSelector((state: AuthenticationState) => state);
  const [products, setProducts] = useState<any[]>(ticket?.products || []);
  const [tempProducts, setTempProducts] = useState<any[]>(
    ticket?.products || []
  );
  const [splitProducts, setSplitProducts] = useState<any[]>([]);
  const [motive, setMotive] = useState<string>("");

  // const createPartialTicket = () => {
  //   api(token)
  //     .post(`ticket/${ticket?.id}`, {
  //       products: splitProducts,
  //     })
  //     .then((response) => {
  //       console.log(response);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const columns: ColumnsType<DataType> = [
    {
      title: "Descrição",
      dataIndex: "description",
      key: "description",
      width: 500,
    },
    {
      title: "Quantidade",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "",
      dataIndex: "",
      key: "",
      render: (data) => (
        <div>
          <SwapOutlined
            className="text-lg hover:text-sky-500 hover:cursor-pointer"
            onClick={() => {
              const index = tempProducts.findIndex((p) => p?.id === data?.id);
              if (index !== -1) {
                const [movedProduct] = tempProducts.splice(index, 1);
                setTempProducts([...tempProducts]);
                setSplitProducts([movedProduct, ...splitProducts]);
              } else {
                const index = splitProducts.findIndex(
                  (p) => p?.id === data?.id
                );
                if (index !== -1) {
                  const [movedProduct] = splitProducts.splice(index, 1);
                  setSplitProducts([...splitProducts]);
                  setTempProducts([movedProduct, ...tempProducts]);
                }
              }
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="grid  grid-cols-5 align-center justify-center">
        <div className=" col-span-2">
          <div className="text-center text-lg font-bold">Este Ticket</div>
          <div>
            <p>Status:</p>
            <p className="my-5">Aguardando Analise</p>
          </div>
          <Divider />
          <div>
            <p>Produtos:</p>
            <Table
              className=" overflow-auto"
              size="small"
              columns={columns}
              dataSource={tempProducts}
              pagination={false}
              style={{ maxHeight: "25vh" }}
            />
          </div>
        </div>
        <div></div>
        <div className=" col-span-2">
          <div className="text-center text-lg font-bold">
            Novo Ticket Parcial
          </div>
          <div>
            <p>Status:</p>
            <Select className="w-full" defaultValue={"ASSEMBLE_REJECTED"}>
              <Select.Option value="ASSEMBLE_REJECTED">Rejeitado</Select.Option>
              <Select.Option value="ASSEMBLE_TECHNICAL_ASSISTANCE">
                Assistencia Técnica
              </Select.Option>
            </Select>
          </div>
          <Divider />
          <div>
            <p>Produtos:</p>
            <Table
              className=" overflow-auto"
              size="small"
              columns={columns}
              dataSource={splitProducts}
              pagination={false}
              style={{ maxHeight: "25vh" }}
            />
          </div>
        </div>
      </div>
      <div className="my-2">
        <div className="text-center text-md font-bold">Motivo</div>
        <TextArea
          value={motive}
          onChange={(e) => setMotive(e.target.value)}
          size="small"
          rows={3}
        />
      </div>
      <Divider className="my-10" />
      <div className="flex justify-center">
        <Button type="primary">Gerar Parcial</Button>
      </div>
    </>
  );
};

export default SplitTicket;
